var map = {
	"./001-artist.png": "feaf",
	"./002-artist.png": "eac3",
	"./003-astronaut.png": "98c5",
	"./004-astronaut.png": "a524",
	"./005-carnival-mask.png": "ba60",
	"./006-carnival-mask.png": "9b8e",
	"./007-doctor.png": "8d07",
	"./008-doctor.png": "dbb8",
	"./009-judge.png": "6c96",
	"./010-judge.png": "a660",
	"./011-operator.png": "dc48",
	"./012-moderator.png": "8ebb",
	"./013-Pharmacist.png": "c277",
	"./014-Pharmacist.png": "37f1",
	"./015-captain.png": "d706",
	"./016-pilot.png": "0723",
	"./017-post-office.png": "a6ad",
	"./018-postman.png": "64e7",
	"./019-seaman.png": "e5f5",
	"./020-navy.png": "4d6b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0606";